import { redirectToSsoAuthorization } from 'util/redirectToSsoAuthorization';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { JoinCallButton } from 'ui/components/Button';
import { JoinPanelButtons } from './view';

type JoinPanelProps = {
    isAuthorized: boolean;
    connectDisabled: boolean;
    connectToRoom: () => void;
};

export const JoinPanel = ({ isAuthorized, connectDisabled, connectToRoom }: JoinPanelProps) => {
    const { t } = useTranslation();

    const onJoin = useCallback(() => {
        redirectToSsoAuthorization();
    }, []);

    return (
        <JoinPanelButtons>
            {isAuthorized ? (
                <JoinCallButton
                    disabled={connectDisabled}
                    onClick={connectToRoom}
                    variant="primary"
                    size="large"
                    data-cy="openVcsOpen"
                >
                    {t('web_call_button')}
                </JoinCallButton>
            ) : (
                <>
                    <JoinCallButton onClick={connectToRoom} variant="secondary" size="large" data-cy="openVcsOpenGuest">
                        {t('web_call_button_guest')}
                    </JoinCallButton>
                    <JoinCallButton onClick={onJoin} autoFocus data-cy="openVcsOpenAuth">
                        {t('web_call_button_login_user')}
                    </JoinCallButton>
                </>
            )}
        </JoinPanelButtons>
    );
};
